import { Component } from "react";
import { connect } from "react-redux";
import {set_datapage, SetLanguage, getLanguage, AddCountDataPage} from 'redux/actions/DataPageAction'
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";


class Change extends Component {
    _isMounted = false;
    requestInit = null;
    refFilterRecursos = null
    state = {
        listRecursos: [],
        listEmpresas: [],
        listPaises: [],
        import_vars: []
    }
    filter = {
        buscar: '',
        recurso: -1,
        pais: -1,
        empresa: -1,
        // dublin: -1
    }
    table = null
    datatable = null

    // eslint-disable-next-line no-useless-constructor
    constructor (props) {
        super(props)
      // console.log('CHANGE IDIOMA', this, props)
      this.requestInit = axios.CancelToken.source()

    }
    componentDidMount () {
        console.log('LENGUGA', this.props.location.search, this.props.history.location.search, window.location)

        let preUrlSS = new URLSearchParams(this.props.location.search)
        console.log('LENGUGA', preUrlSS.get('preUrl'))
        let  preObjUrl = new URL(preUrlSS.get('preUrl'))
        let searchPrev = new URLSearchParams(preObjUrl.search)


        this._isMounted = true;
        let idioma =  this.props.match.params.idioma
        searchPrev.set('lang', idioma)
        preObjUrl.search = '?' + searchPrev.toString()
        axios.defaults.params['lang'] = idioma
        axios.put(baseUrl('aro/translate/change_language'), { 
          lang: idioma,
          cancelToken: this.requestInit.token 
        }).then(res => {
            this.props.SetLanguage({})
            window.location = preObjUrl.href
          // this.props.history.goBack()
          // this.getGeneral(preObjUrl.href)
          // console.log('LENGUGAS', preObjUrl.href)

          // this.props.history.push(localUrl(preObjUrl.pathname + preObjUrl.search))
        })
    }
    getGeneral (url) {
        return axios.get(baseUrl(`aro/translate/language/file/general.json`), {
          params: {hash: '',m:'cites'},
          
        }).then(resL => {
          console.log('OBTENIENDO EL LENGUGA', resL)
          if (resL.data.success) {
            localStorage.setItem('languageValues', JSON.stringify(resL.data.data.json))
            this.props.SetLanguage(resL.data.data.json)
            localStorage.setItem('languageHashFile', resL.data.data.hash)
          } else {
            //get fronm storga
            // let lang = localStorage.getItem('languageValues')
            // let fjson = {}
            // if (lang) {
            //   try {
            //     fjson = JSON.parse(localStorage.getItem('languageValues'))
            //   } catch (err) {
            //     fjson = {}
            //   }
            // }
            // this.props.SetLanguage(fjson)
          }
          // this.props.AddCountDataPage()
          window.location = url
        })
    }
    // componentWillMount () {
        
      
    // }
    componentWillUnmount() {
        this._isMounted = false;
        if (this.requestInit) this.requestInit.cancel()


    }

    

    render() {
        return (
         <h3>Wait...</h3>
        )
    }
}

export default connect(null, {set_datapage, SetLanguage, getLanguage, AddCountDataPage})(Change)